<script setup lang="ts">
import { useToast } from "vue-toastification";

import CardHeader from "@/common/components/card/CardHeader.vue";
import CardVue from "@/common/components/card/CardVue.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import { useCurrentUser } from "@/users/public/composables";

import { useCreateAdminUserMutation } from "../api/queries";

definePage({
  meta: {
    auth: ["Developer.Access"],
  },
});

const toast = useToast();

const { mutateAsync: createAdminUserAsync } = useCreateAdminUserMutation();

const createAdminUserHandler = async (formValue: {
  email: string;
  password: string;
}) => {
  await createAdminUserAsync({
    email: formValue.email,
    password: formValue.password || null,
  });

  toast.success("Admin user created successfully");
};

const breadcrumbs = [
  {
    label: "Admin tools",
    to: "#",
  },
];

const { userHasPermission } = useCurrentUser();
</script>

<template>
  <PageWrapper
    title="Admin tools"
    :breadcrumb-links="breadcrumbs"
  >
    <CardVue>
      <CardHeader>
        <template #default>Create admin user</template>
      </CardHeader>
      <FormKitForm
        submit-label="Create Admin User"
        :user-can-write="userHasPermission('Users.Create')"
        @submit="createAdminUserHandler"
      >
        <div class="grid grid-cols-2 gap-2">
          <FormKit
            type="email"
            name="email"
            label="Email"
            placeholder="user@matchwornshirt.com"
            validation="required|email"
          />
          <FormKit
            type="password"
            name="password"
            label="Password"
            validation="length:8"
          />
        </div>
      </FormKitForm>
    </CardVue>
  </PageWrapper>
</template>
